import Response from './Response';

class API {
  constructor(app) {
    this.app = app;
    this.restUrl = window.bvm.rest
      ? `${window.bvm.rest}bvmsports-framework/v1/`
      : null;
  }

  /**
   * @param {string} path
   * @param {URLSearchParams} params
   * @returns {Response}
   */
  async get(path, params, config = {}) {
    try {
      const headers = {};

      if (params.get('nonce')) {
        headers['X-WP-Nonce'] = params.get('nonce');
      }

      const query = await fetch(this.getUrl(path, params), {
        method: 'GET',
        headers,
        signal: config.signal || null,
      });

      const result = await query.json();

      if (! query.ok) {
        console.error(result);
        throw new Error(`[${query.status}] ${query.statusText}`);
      }

      return new Response()
        .setSuccess(result.success ?? false)
        .setData(result.data ?? [])
        .setTotal(result.total ?? 0)
        .setMessage(result.message ?? '');
    } catch (error) {
      return new Response().setMessage(error.message);
    }
  }

  /**
   * @param {string} path
   * @param {URLSearchParams} params
   * @returns {string} REST URL
   */
  getUrl(path, params) {
    return `${this.restUrl}${path}?${params.toString()}`;
  }

  /**
   * @param {string} path
   */
  getRestUrl(path) {
    if (! path) {
      return this.restUrl;
    }

    return `${this.restUrl}${path}`
  }
}

export default API;
